export const columns = [
  { dataField: 'departmentName', text: 'Department Name' },
  { dataField: 'fullName', text: 'Full Name' },
];
export const defaultSorted = [
  {
    dataField: 'fullName',
    order: 'asc',
  },
];
